import { useEffect, useState } from "react";
import { localStorageClass } from "../apollo/local/storage";

/**
 * Hook per rilevare tipo di device (iPad, tablet Android, mobile, desktop)
 */
export function useIsMobileVersion() {
   const [mobileVersion, setMobileVersion] = useState(false);

   useEffect(() => {
      // Imposta il valore iniziale
      setMobileVersion(localStorageClass.isMobileVersion());

      // Listener per cambiamenti nel localStorage
      const handleStorageChange = () => {
         setMobileVersion(localStorageClass.isMobileVersion());
      };

      // Aggiunge listener per eventi storage
      window.addEventListener("storage", handleStorageChange);

      // Cleanup
      return () => {
         window.removeEventListener("storage", handleStorageChange);
      };
   }, []);

   return mobileVersion;
}
